type ProductTypeInfo = {
  type: string;
  exclude: string[];
  excludeWhenPrescriptionNeeded: string[];
};

export enum ShopifyProductTypes {
  SUNGLASSES = 'Sunglasses',
  OPTICALS = 'Opticals',
  BLUELIGHT = 'Bluelight',
}

export const ProductTypesInfo: ProductTypeInfo[] = [
  {
    type: ShopifyProductTypes.SUNGLASSES,
    exclude: [
      'blue-light-filter',
      'blue-light-filter-free',
      'thinlenses',
      'singlebluelight',
      'sliping-og-tilpasning',
      'tilpasningstillegg-egen-brille',
    ],
    excludeWhenPrescriptionNeeded: ['blue-light-filter', 'blue-light-filter-free', 'thinlenses'],
  },
  {
    type: ShopifyProductTypes.OPTICALS,
    exclude: [
      'blue-light-filter',
      'singlebluelight',
      'blue-light-filter-free',
      'polarisert',
      'sliping-og-tilpasning',
      'tilpasningstillegg-egen-brille',
    ],
    excludeWhenPrescriptionNeeded: ['blue-light-filter-free', 'polarisert'],
  },
  {
    type: ShopifyProductTypes.BLUELIGHT,
    exclude: [
      'blue-light-filter',
      'blue-light-filter-free',
      'single-vision',
      'polarisert',
      'sliping-og-tilpasning',
    ],
    excludeWhenPrescriptionNeeded: ['blue-light-filter', 'blue-light-filter-free', 'polarisert'],
  },
];

export const combinedProducts: Record<string, string> = {
  'single-vision': 'sliping-og-tilpasning',
  progressives: 'sliping-og-tilpasning',
};
export const disabledProductHandle = ['progressives'];
export const glassesNeedingPrescription = [7032903663803, 7032901042363, 7200343949499];
